<template>
  <div class="dsf-online-login-tab-plan dsf-netcom-login-tab-qrcode">
    <!-- <div class="info">请使用统计云App扫码登录</div> -->
    <div class="qrcode" v-bind="styleAttr" @click="heanlderQrcode">
      <span v-show="time == 0 || isGetCodeRequest">
        <DsfIcon :class="isGetCodeRequest && 'active'" name="shuaxin"></DsfIcon>
        二维码已失效<br />点击刷新
      </span>
    </div>
    <div class="info">请使用统计云App扫码登录</div>
  </div>
</template>

<script>
export default {
  name: "TabNetcomPlanQrcode",
  data() {
    return {
      loading: false,
      username: "",
      imgUrl: "",
      time: 0,
      setIntervalVerifyQrcode: null,
      isVerifyCodeRequest: false, // true 正在请求 false 请求完
      isGetCodeRequest: false, // true 正在请求 false 请求完
    };
  },
  props: {
    pinPlaceholder: {
      type: String,
      default: "请输入PIN码",
    },
  },
  created() {},
  computed: {
    styleAttr() {
      if (this.imgUrl) {
        return {
          style: {
            "background-image": "url(" + this.imgUrl + ")",
          },
        };
      } else {
        return {};
      }
    },
  },
  methods: {
    heanlderQrcode() {
      if (this.time == 0) {
        this.getQrcode();
      } else {
        return;
      }
    },
    getQrcode() {
      if (this.isGetCodeRequest) {
        return false;
      }
      this.time = 0;
      this.isGetCodeRequest = true;
      dsf.http
        .get(`/secret/qrCode/getLoginQrCode`)
        .done((res) => {
          if (res.success) {
            this.imgUrl = "data:image/jpeg;base64," + res.data.base64;
            this.time = 1;
            this.setIntervalVerifyQrcode = setInterval(() => {
              this.time = this.time + 2;
              if (this.time > 30) {
                this.clearIntervalVerifyQrcode();
              } else {
                this.verifyCode(res.data.code);
              }
            }, 2 * 1000);
          } else {
            dsf.layer.message(res.message || "请求异常", false);
          }
        })
        .always(() => {
          this.isGetCodeRequest = false;
        });
    },

    verifyCode(code) {
      if (this.isVerifyCodeRequest) {
        return false;
      }
      this.isVerifyCodeRequest = true;
      let params = {
        code: code,
        loginType: "scan",
      };
      this.$webAPI
        .login(params)
        .then(({ data, message, success, state }) => {
          if (success) {
            if (data.userType == 2) {
              return this.saToLogin(data);
            } else {
              if (data.redirectPath) {
                location.replace(data.redirectPath);
              } else {
                dsf.layer.message("跳转路径不存在", false);
                this.clearIntervalVerifyQrcode();
              }
            }
          } else if (state == 80007) {
            this.clearIntervalVerifyQrcode();
            dsf.layer.message(message || "请求异常", false);
          }
        })
        .finally(() => {
          this.isVerifyCodeRequest = false;
        });
    },
    saToLogin(data) {
      return dsf.http.get("/survey/assistant/getSurveyAssistantSsoUrl").then((res) => {
        let { success, message, data } = res.data;
        if (success) {
          if (data) {
            location.replace(data);
          } else {
            dsf.layer.message("跳转路径不存在", false);
          }
        } else {
          dsf.layer.message(message, false);
        }
      });
    },
    clearIntervalVerifyQrcode() {
      this.time = 0;
      this.imgUrl = "";
      if (this.setIntervalVerifyQrcode) {
        clearInterval(this.setIntervalVerifyQrcode);
        this.setIntervalVerifyQrcode = null;
      }
    },
  },
  beforeDestroy() {
    this.clearIntervalVerifyQrcode();
  },
};
</script>
